import { PageShell } from '@/components/layout/PageShell';
import { WikiDocumentPreview } from '@/routes/wiki/DocumentPreview';

interface Props {
  documentId: string;
}

export function AdminWikiDocumentPreview({ documentId }: Props) {
  return (
    <PageShell>
      <WikiDocumentPreview documentId={documentId} isAdmin backTo="/admin/wikis/documents" />
    </PageShell>
  );
}
